import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import SkynetIcon from "../../Fundamentals/SkynetIcon";
import BoldMatchingText from "../../Fundamentals/BoldMatchingText";

import routes from "../../../Constants/routes";
import terminationReasonsActions from "../../../Actions/InternalCustomerAdmin/terminationReasonsActions";


export function TerminationReasonsTable({ terminationReasons, searchQuery = '' }) {
    const { t } = useTranslation();

    return <table className="table table-stripe skynet-table-no-divider table-active">
        <thead>
            <tr>
                <th className="col-8">{t('terminationreasonstable.reason')}</th>
                <th className="col-1">{t('common.edit')}</th>
                <th className="col-1">{t('common.delete')}</th>
            </tr>
        </thead>
        <tbody>
            {terminationReasons && terminationReasons.map((reason) => (
                <TerminationReasonRow key={reason.id} reason={reason} searchQuery={searchQuery} />
            ))}
        </tbody>
    </table>
};

function TerminationReasonRow({ reason, searchQuery = ''  }) {
    const [active, setActive] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const hasSubReasons = (reason) => {
        return reason.subReasons && reason.subReasons.length > 0;
    };

    const hasMatchingSubReasons = (reason, query) => {
        if (!query.trim()) return false;
      
        return reason.subReasons?.some(subReason =>
            subReason.name.toLowerCase().includes(query.toLowerCase())
        );
    };

    useEffect(() => {
        if (!hasSubReasons(reason)) {
            setActive(false);
            return;
        }

        if (searchQuery.trim() && hasMatchingSubReasons(reason, searchQuery)) {
            setActive(true);
            return;
        }

        if (!searchQuery.trim()) {
            setActive(false);
            return;
        }

        if (searchQuery.trim() && !hasMatchingSubReasons(reason, searchQuery)) {
            setActive(false);
            return;
        }
    }, [reason.subReasons, searchQuery]);

    const handleRowClick = () => {
        if (hasSubReasons(reason)) {
            setActive(!active);
        }
    };

    const navigateToEdit = (reasonId) => {
        const params = new URLSearchParams();
        params.append("ReasonId", reasonId);
        navigate({
            pathname: routes.icaTerminationReasonsEdit,
            search: params.toString()
        });
    }

    const handleDelete = (reasonId) => {
        dispatch(terminationReasonsActions.deleteTerminationReason(reasonId, () => dispatch(terminationReasonsActions.getTerminationReasons())));
    };

    const handleSubReasonDelete = (subReasonId, reasonId) => {
        dispatch(terminationReasonsActions.deleteSubTerminationReason(subReasonId, reasonId, () => dispatch(terminationReasonsActions.getTerminationReasons())));
    };

    return (
        <>
            <tr className={active ? 'active' : undefined} onClick={handleRowClick}>
                <td className={active ? 'bold' : undefined}>
                    <span className={`caret caret-lg${active ? ' open' : ''}${!hasSubReasons(reason) ? ' invisible' : ''}`} />
                    <div className="ml-24 d-inline-block">
                        <BoldMatchingText text={reason.name} query={searchQuery} />
                    </div>
                </td>
                <td>
                    <SkynetIcon icon={'vismaicon-edit'} onClick={() => navigateToEdit(reason.id)} />
                </td>
                <td>
                    <SkynetIcon icon={'vismaicon-delete'} onClick={() => handleDelete(reason.id)}  />
                </td>
            </tr>
            {active && reason.subReasons.map((subReason, subIndex) => (
                <tr key={subReason.id || subIndex}>
                    <td style={{paddingLeft: '7.2rem'}}>
                        <BoldMatchingText text={subReason.name} query={searchQuery} />
                    </td>
                    <td></td>
                    <td>
                        <SkynetIcon icon={'vismaicon-delete'} onClick={() => handleSubReasonDelete(subReason.id, reason.id)} />
                    </td>
                </tr>
            ))}
        </>
    );
};